import { render } from "./Complains.vue?vue&type=template&id=27f86caa"
import script from "./Complains.vue?vue&type=script&lang=js"
export * from "./Complains.vue?vue&type=script&lang=js"

import "./Complains.vue?vue&type=style&index=0&id=27f86caa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__